import { Loader2Icon } from "lucide-react";

type GenericSpinnerProps = {
    msg?: string;
}
export default function GenericSpinner({ msg }: GenericSpinnerProps) {
    return <div className="flex items-center justify-center gap-2 font-rad text-value uppercase tracking-[.12em] text-faint scrim">
        <Loader2Icon className="shrink-0 size-4 animate-spin-slow text-accent drop-scrim" strokeWidth={2.5} />
        {msg}
    </div>;
}
